"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProjectLimits = {
    CONDITION: {
        SIZE: 255,
    },
    PAGE: {
        CONDITIONS: 100,
        CONTAINS: 50,
        REGEX: 10,
    },
    PERIOD: {
        MAX_DAY: 92,
    },
    SEGMENT: {
        GOALS: 9,
        TEXT_SEEN: 1
    },
    INTEGRATION: {
        SEGMENTS: 100,
    },
    REGEX: {
        MATCH: 5,
        ALTERNATION: 15,
    },
};
//# sourceMappingURL=project.limits.js.map